import { render, staticRenderFns } from "./WeFixRepairHome.vue?vue&type=template&id=3475d1de&"
import script from "./WeFixRepairHome.vue?vue&type=script&lang=js&"
export * from "./WeFixRepairHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports